import { useState } from "react";
import Textarea from "../../../../componentes/input/textarea";
import Button from "../../../../componentes/button/button";

// Etapa terminal "Cadastro/Alteração" — quem executa a mudança no sistema confirma que ela foi
// de fato realizada (obrigatório para concluir) e pode registrar detalhes adicionais (opcional).
export default function EtapaAjusteGtcCadastroAlteracao({ acoes = [], acaoEmExecucao, onExecutarAcao }) {
    const [confirmado, setConfirmado] = useState(false);
    const [detalhes, setDetalhes] = useState("");

    const podeConcluir = acoes.includes("CONCLUIR");

    function concluir() {
        if (!confirmado) return;
        const texto = detalhes.trim();
        onExecutarAcao("CONCLUIR", { dados: { confirmacaoAlteracao: true, ...(texto ? { detalhes: texto } : {}) } });
    }

    return (
        <div className="flex flex-col gap-4">
            <p className="text-sm text-muted-foreground">
                Realize a alteração no sistema e confirme abaixo antes de concluir a solicitação.
            </p>

            <label className="flex items-center gap-2.5 px-3 py-2 border border-input rounded-md text-sm font-medium text-foreground/80 cursor-pointer hover:bg-muted w-fit">
                <input
                    type="checkbox"
                    checked={confirmado}
                    onChange={e => setConfirmado(e.target.checked)}
                    className="h-4 w-4 rounded border-input text-primary focus:ring-2 focus:ring-primary/15"
                />
                Confirmo que a alteração foi realizada <span className="text-destructive">*</span>
            </label>

            <Textarea label="Detalhes" value={detalhes} onChange={e => setDetalhes(e.target.value)} rows={3} placeholder="Opcional" />

            <div className="flex justify-end">
                {podeConcluir && (
                    <Button
                        variant="green"
                        label="Concluir"
                        iconLeft="fa fa-flag-checkered"
                        loading={acaoEmExecucao === "CONCLUIR"}
                        disabled={!confirmado}
                        onClick={concluir}
                    />
                )}
            </div>
        </div>
    );
}
